import React from 'react';
import ReactDOM from 'react-dom';
import { concat, clone } from 'ramda';
import { Icon, Spin, Button, Switch, Modal, Input, Tree } from 'antd';
import Context from '../Container/Context';
import { asserts, network, generators, maths, strings } from '../../../utils';
import api from '../../../config/api';
import { useModel, useDidMount } from '../../use';
import { message } from '../../biz';

import CatContent from './CatContent';

import './CatMenu.less';

const { TreeNode } = Tree;

const { generatorArray, generatorObject } = generators;
const initialState = {
  menus: [],
  visible: false,
};

const checkSvg = `${process.env.TARGET}static/imgs/check_full.svg`;
const closeSvg = `${process.env.TARGET}static/imgs/close_square.svg`;

const updateMenu = (state, payload) => ({ ...state, menus: payload });
const updateMaterial = (state, payload) => ({ ...state, material: payload });
const updateVisible = (state, payload) => ({ ...state, visible: payload });

const fetchMenu = async ({ dispatch }) => {
  const response = await network.get(api.home.catalogue);
  if (response.success) {
    if (!response.data.success) {
      message.error(response.data.message);
      return;
    }
    const wireRod = [{ catName: '现货精线', catId: 'wireRod' }];
    const list = concat(generatorArray(generatorObject(response.data).data), wireRod);
    dispatch('updateMenu')(list);
  }
};

const CatMenu = () => {
  const { history, principal } = React.useContext(Context);
  const mainRef = React.useRef();
  const firstContentRef = React.useRef();
  const secondContentRef = React.useRef();
  const {
    state: { menus, visible },
    dispatch,
    loading,
  } = useModel({
    state: initialState,
    reducers: { updateMenu, updateVisible, updateMaterial },
    effects: { fetchMenu },
  });

  // eslint-disable-next-line no-unused-vars
  const [activeKey, setActiveKey] = React.useState('');
  // console.warn(activeKey);
  const [hoverFix, setHoverFix] = React.useState(maths.getSnowFlake());

  const [carouselReact, setCarouselReact] = React.useState('');

  const judgementFn = (location) => {
    const shouldVisible = ['/', '/home'].includes(location.pathname);
    dispatch('updateVisible')(shouldVisible);
  };

  const heightFix = () => {
    const theme = window.tmConfig;
    const isScale = theme.isScale();
    if (isScale) {
      setCarouselReact('media-homepage-menu-height');
      const height = theme.getContentHeight();
      const heightStyle = `calc(100vh - ${height}px)`;
      document.querySelector('.category-menu-main').style['height'] = heightStyle;
    } else {
      setCarouselReact('media-homepage-menu-height-standard');
    }
  };

  React.useEffect(() => {
    heightFix();
  });

  React.useEffect(() => {
    // 跳转链接时，监听是否显示头
    const unlisten = history.listen((location) => {
      judgementFn(location);
    });
    return () => {
      unlisten();
    };
  });

  useDidMount(() => {
    judgementFn(history.location);
    dispatch('fetchMenu')();
  });

  const showImage = (e) => {
    const operationImg = e.srcElement.querySelector('.tag-img');
    // e.clientY 是鼠标距离可见区域顶部的距离。 450 是菜单区域高度。 160 是头部高度
    // 这里按逻辑做计算应该是： 菜单区域高度+头部高度-鼠标距离顶部距离 > 可以显示悬浮图片高度 时，在下面，否则在上面
    // 即: 450 + 160 - e.screenY > 80 * 2 <--> e.screenY < 450 + 132 - 80 * 2
    // 80 为一个图的高 变为两倍是为了留有余地，80为参考值，实际上取的是 .tag-img 的高度，更准确
    const topHeight =
      document.querySelector('.js-topBar').clientHeight +
      document.querySelector('.js-header').clientHeight;
    const offsetTop = window.pageYOffset;
    const menu_height = document.body.querySelector('.category-menu-main').offsetHeight; // default 450
    const visibleHeight = menu_height + (topHeight - offsetTop);
    const imgHeightArea = operationImg.offsetHeight * 1.5;
    // const className = e.clientY < visibleHeight - imgHeightArea ? 'tag-img-bottom' : 'tag-img-top';
    // todo  2023/08/24  未知设置top的场景，因为需要加粘性布局的stickyHeader，所以设置成了一个死值  如出现问题，需要再进行调整修改
    const className = 'tag-img-bottom';
    operationImg.className = operationImg.className + ' ' + className;
  };

  const hideImage = (e) => {
    e.srcElement.querySelector('.tag-img').className = 'tag-img';
  };

  React.useEffect(() => {
    const cardRefDOM = ReactDOM.findDOMNode(mainRef.current);
    setTimeout(() => {
      Array.prototype.map.call(cardRefDOM.querySelectorAll('.sub-content-tag'), function(tab) {
        tab.addEventListener('mouseenter', showImage);
        tab.addEventListener('mouseleave', hideImage);
      });
    }, 0);
    return () => {
      Array.prototype.map.call(cardRefDOM.querySelectorAll('.sub-content-tag'), function(tab) {
        tab.removeEventListener('mouseenter', showImage);
        tab.removeEventListener('mouseleave', hideImage);
      });
    };
  });

  const memorizedMainMenu = React.useMemo(() => {
    const pushAway = (path) => {
      history.push(path);
      setHoverFix(maths.getSnowFlake());
    };
    const handleMenuClick = () => {
      history.replace('/wireRod');
    };
    return menus.map((menu) => (
      <React.Fragment key={menu.catId}>
        <div
          className="category-menu-main-item pointer"
          onClick={menu.catId === 'wireRod' ? handleMenuClick : undefined}
        >
          <div className="category-menu-main-item-title">
            {menu.catName}
            <Icon className="category-menu-main-item-arrow" type="right" />
          </div>
          {menu.catId !== 'wireRod' && (
            <CatContent
              scatId={menu.catId}
              subMenu={generatorArray(menu.children)}
              standardMenu={generatorObject(menu.children2)}
              material={generatorArray(menu.materialList)}
              pushAway={pushAway}
              onTabChange={(key) => setActiveKey(key)}
            />
          )}
        </div>
      </React.Fragment>
    ));
  }, [menus]); // eslint-disable-line
  const [modalVisible, setModalVisible] = React.useState(false);
  const handleCancel = () => {
    if (
      customMenuInitial &&
      JSON.stringify(customMenuRef.current) !== JSON.stringify(customMenuInitial)
    ) {
      Modal.confirm({
        zIndex: 1066,
        title: '提示',
        content: '当前存在未提交的修改，确定关闭？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          setModalVisible(false);
          init();
          // mainRef.current.classList.remove('hidden');
        },
      });
    } else {
      setModalVisible(false);
      init();
      // mainRef.current.classList.remove('hidden');
    }
  };

  // allSmallItem 存放所有原有的三级菜单（即小类），用于在Tree中勾选后的节点key比对，过滤掉一二级的key，保留三级的key显示在三级菜单中
  const allSmallItems = [];
  const allMenus = React.useMemo(() => {
    const arr = menus.map((item) => {
      const obj = {
        title: item.catName,
        key: item.catCode,
        children: item.children,
      };
      if (obj.children && obj.children.length) {
        obj.children = obj.children.map((item2) => {
          const obj2 = {
            title: item2.catName,
            key: item2.catCode,
            children: item2.children,
          };
          if (obj2.children && obj2.children.length) {
            obj2.children = obj2.children.map((item3) => {
              const obj3 = {
                title: item3.catName,
                key: item3.catCode,
                icoSrc: item3.icoSrc,
              };
              allSmallItems.push({
                catName: obj3.title,
                catCode: obj3.key,
                icoSrc: item3.icoSrc,
                fixedMenuFlag: '0',
              });
              return obj3;
            });
          }
          return obj2;
        });
      }
      return obj;
    });
    return arr;
  }, [menus, allSmallItems]);
  // 自定义菜单数据
  const [customMenu, setCustomMenu] = React.useState([]);
  const [customMenuInitial, setCustomMenuInitial] = React.useState([]);
  // 用ref存总数据，每次setCustomMenu时同步更新customMenuRef.current，更新总菜单取值时直接从customMenuRef拿最新值，避免数据丢失情况
  const customMenuRef = React.useRef({});
  customMenuRef.current = customMenu || [];
  // 一二三级菜单状态区
  const [currentEditItem, setCurrentEditItem] = React.useState(null);
  const [currentEditItem2, setCurrentEditItem2] = React.useState(null);
  const [currentSelect1, setCurrentSelect1] = React.useState(null);
  const [currentSelect2, setCurrentSelect2] = React.useState(null);
  const currentSelect2Ref = React.useRef('');
  currentSelect2Ref.current = currentSelect2;

  const [currentMenuSecond, setCurrentMenuSecond] = React.useState([]);
  const [currentMenuThird, setCurrentMenuThird] = React.useState([]);

  const [firstAddList, setFirstAddList] = React.useState([]);
  const [secondAddList, setSecondAddList] = React.useState([]);

  const [firstChangeValue, setFirstChangeValue] = React.useState('');
  const [secondChangeValue, setSecondChangeValue] = React.useState('');
  // 全部菜单状态区
  const [expandedKeys, setExpandedKeys] = React.useState([]);
  const [autoExpandParent, setAutoExpandParent] = React.useState(true);
  const [checkedKeys, setCheckedKeys] = React.useState([]);
  const [treeVisible, setTreeVisible] = React.useState(false);
  const isLoginIn = asserts.isExist(principal);

  const [customOpeartionVisible, setCustomOpeartionVisible] = React.useState(false);

  const [showCustomMenu, setShowCustomMenu] = React.useState(false);

  React.useEffect(() => {
    if (isLoginIn) {
      setCustomOpeartionVisible(true);
      network.get(`${api.home.catalogue}?menuType=custom`).then((res) => {
        if (res.success) {
          setCustomMenu(res.data.data || []);
          setCustomMenuInitial(res.data.data);
          customMenuRef.current = res.data.data || [];
        }
      });
      const loginName = localStorage.getItem('loginName');
      const menuOpen = localStorage.getItem(`${loginName}-custom-menu`) === 'true';
      setShowCustomMenu(menuOpen);
    }
  }, [isLoginIn]);

  const memorizedCustomMenu = React.useMemo(() => {
    const pushAway = (path) => {
      history.push(path);
      setHoverFix(maths.getSnowFlake());
    };
    const handleMenuClick = () => {
      history.replace('/wireRod');
    };
    return (
      customMenuInitial &&
      customMenuInitial.map((menu) => (
        <React.Fragment key={menu.catId}>
          <div
            className="category-menu-main-item pointer"
            onClick={menu.catId === 'wireRod' ? handleMenuClick : undefined}
          >
            <div className="category-menu-main-item-title">
              {menu.catName}
              <Icon className="category-menu-main-item-arrow" type="right" />
            </div>
            {menu.catId !== 'wireRod' && (
              <CatContent
                type="custom"
                scatId={menu.catId}
                subMenu={generatorArray(menu.children)}
                standardMenu={generatorObject(menu.children2)}
                material={generatorArray(menu.materialList)}
                pushAway={pushAway}
                onTabChange={(key) => setActiveKey(key)}
              />
            )}
          </div>
        </React.Fragment>
      ))
    );
  }, [customMenuInitial]); // eslint-disable-line
  const handleItemEdit = (id) => {
    setCurrentEditItem(id);
  };
  const handleItemEdit2 = (id) => {
    setCurrentEditItem2(id);
  };
  const handleSelected1 = (id) => {
    setCurrentSelect1(currentSelect1 !== id ? id : null);
    const item = customMenu.find((i) => i.id === id);
    setCurrentMenuSecond(item && item.children);
    setCurrentSelect2(null);
    currentSelect2Ref.current = null;
    setCurrentEditItem2(null);
    // 点击同一个一级菜单清空二级，三级和树形图必清
    if (currentSelect1 === id) {
      setCurrentMenuSecond([]);
    }
    setCurrentMenuThird([]);
    setTreeVisible(false);
  };
  const handleSelected2 = (id) => {
    setCurrentSelect2(currentSelect2 !== id ? id : null);
    currentSelect2Ref.current = currentSelect2 !== id ? id : null;
    setTreeVisible(currentSelect2 !== id ? true : false);
    const item = (
      customMenu.find((i) => i.id === currentSelect1) || { children: [] }
    ).children.find((item) => item.id === id);
    setCurrentMenuThird((item && item.children) || []);
    const catCodeMap = item && item.children ? item.children.map((item) => item.catCode) : [];
    setCheckedKeys(catCodeMap);
    if (currentSelect2 === id) {
      setCurrentMenuThird([]);
      setTreeVisible(false);
    }
  };

  // Tree 事件操作区
  const renderTreeNodes = (data) =>
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode title={item.title} key={item.key} dataRef={item}>
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode key={item.key} {...item} />;
    });
  const onExpand = (expandedKeys) => {
    // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.
    setExpandedKeys(expandedKeys);
    setAutoExpandParent(false);
  };

  const onCheck = (checkedKeys) => {
    if (currentThirdFixed === '1') {
      message.info('内置菜单不可操作');
      return;
    }
    setCheckedKeys(checkedKeys);
    const checkedItems = [];
    checkedKeys.forEach((item) => {
      for (let i = 0; i < allSmallItems.length; i++) {
        if (allSmallItems[i].catCode === item) {
          checkedItems.push(allSmallItems[i]);
        }
      }
    });
    setCurrentMenuThird(checkedItems);
    // 更新总菜单数据
    const _customMenu = clone(customMenuRef.current);
    _customMenu.forEach((i) => {
      if (i.id === currentSelect1) {
        i.children.forEach((item) => {
          if (item.id === currentSelect2) {
            item.children = checkedItems;
          }
        });
      }
    });
    setCustomMenu(_customMenu);
    customMenuRef.current = _customMenu;
  };

  // 一级菜单新增,确认，删除操作
  const handleAddFirst = () => {
    const newItem = {
      id: maths.genFakeId(),
      catName: '',
      catCode: strings.randomString(8),
      fixedMenuFlag: '0',
      children: [],
    };
    setFirstAddList([...firstAddList, newItem]);
    setTimeout(() => {
      firstContentRef.current.scrollTop = 0;
    }, 100);
  };
  const handleFirstOnchange = (id, val) => {
    const list = clone(firstAddList);
    for (let i = 0; i < list.length; i++) {
      if (list[i].id === id) {
        list[i].catName = val;
        break;
      }
    }
    setFirstAddList([...list]);
  };
  const handleFirstConfirm = (id) => {
    const list = clone(firstAddList);
    const item = list.find((i) => i.id === id);
    const newList = list.filter((i) => i.id !== id);
    setFirstAddList(newList);
    setCustomMenu([...customMenuRef.current, item]);
    handleSelected1(id);
    setTimeout(() => {
      firstContentRef.current.scrollTop = firstContentRef.current.scrollHeight;
    }, 100);
  };
  const handleFirstDelete = (id) => {
    const list = firstAddList.filter((i) => i.id !== id);
    setFirstAddList([...list]);
  };

  // 二级菜单新增,确认，删除操作
  const handleAddSecond = () => {
    if (currentSelect1) {
      const newItem = {
        id: maths.genFakeId(),
        catName: '',
        catCode: strings.randomString(8),
        fixedMenuFlag: '0',
        children: [],
      };
      setSecondAddList([...secondAddList, newItem]);
      setTimeout(() => {
        secondContentRef.current.scrollTop = 0;
      }, 100);
    } else {
      message.info('请先选择一级菜单');
    }
  };
  const handleSecondOnchange = (id, val) => {
    const list = clone(secondAddList);
    for (let i = 0; i < list.length; i++) {
      if (list[i].id === id) {
        list[i].catName = val;
        break;
      }
    }
    setSecondAddList([...list]);
  };
  const handleSecondConfirm = (id) => {
    const list = clone(secondAddList);
    const item = list.find((i) => i.id === id);
    const newList = list.filter((i) => i.id !== id);
    setSecondAddList(newList);
    // 更新总菜单数据
    const _customMenu = clone(customMenuRef.current);
    _customMenu.forEach((i) => {
      if (i.id === currentSelect1) {
        // 此处千万不能解构currentMenuSecond中的值，这个方法里currentMenuSecond还是最初的旧值
        // i.children = [...currentMenuSecond, item];
        i.children = [...(i.children || []), item];
        setCurrentMenuSecond([...i.children]);
      }
    });
    setCustomMenu(_customMenu);
    customMenuRef.current = _customMenu;
    handleSelected2(id);
    setTimeout(() => {
      secondContentRef.current.scrollTop = secondContentRef.current.scrollHeight;
    }, 100);
  };
  const handleSecondDelete = (id) => {
    const list = secondAddList.filter((i) => i.id !== id);
    setSecondAddList([...list]);
  };
  const handleSubmit = () => {
    setBtnLoading(true);
    network({
      url: api.home.saveCustMenu,
      method: 'post',
      data: customMenuRef.current,
    }).then((res) => {
      setBtnLoading(false);
      if (res.success) {
        message.success('操作成功');
        window.location.reload();
      } else {
        message.error(res.message);
      }
    });
  };
  const init = () => {
    setCustomMenu(customMenuInitial);
    customMenuRef.current = customMenuInitial;
    setCurrentEditItem(null);
    setCurrentEditItem2(null);
    setCurrentSelect1(null);
    setCurrentSelect2(null);
    currentSelect2Ref.current = null;
    setCurrentMenuSecond([]);
    setCurrentMenuThird([]);
    setFirstAddList([]);
    setSecondAddList([]);
    setExpandedKeys([]);
    setAutoExpandParent(true);
    setCheckedKeys([]);
    setTreeVisible(false);
  };
  // 重置
  const handleInitial = () => {
    Modal.confirm({
      zIndex: 1066,
      title: '提示',
      content: '该操作将撤销所有变更，确定吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        init();
      },
    });
  };

  const currentThirdFixed = (
    (currentMenuSecond || []).filter((i) => i.id === currentSelect2)[0] || {}
  ).fixedMenuFlag;

  const [btnLoading, setBtnLoading] = React.useState(false);
  return (
    <>
      <Modal
        zIndex={1065}
        className="custom-menu-modal"
        title={<span style={{ color: '#333' }}>自定义菜单</span>}
        visible={modalVisible}
        onCancel={handleCancel}
        footer={
          <div>
            <Button onClick={handleInitial}>重置</Button>
            <Button onClick={handleCancel}>取消</Button>
            <Button type="primary" onClick={handleSubmit} loading={btnLoading}>
              提交
            </Button>
          </div>
        }
        destroyOnClose
        centered
        maskClosable={false}
      >
        {/* 一级菜单区域 */}
        <div className="custom-menu custom-menu-first">
          <div className="custom-menu-title">
            <span>
              <Icon type="appstore" />
              &nbsp;一级菜单
            </span>
            <span className="right-icon">
              <Icon type="plus-square" onClick={handleAddFirst} />
            </span>
          </div>
          <div
            className="custom-menu-content"
            ref={(ref) => {
              firstContentRef.current = ref;
            }}
          >
            {firstAddList.map((item) => (
              <div className="custom-menu-item-add" key={item.id}>
                <Input
                  className="custom-menu-item-input"
                  onChange={(e) => handleFirstOnchange(item.id, e.target.value)}
                />
                &nbsp;
                <img
                  src={checkSvg}
                  width="30"
                  alt="确定"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFirstConfirm(item.id);
                  }}
                />
                &nbsp;
                <img
                  src={closeSvg}
                  width="30"
                  alt="删除"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFirstDelete(item.id);
                  }}
                />
              </div>
            ))}
            {customMenu &&
              customMenu.map((item, index) => (
                <div key={item.id}>
                  {currentEditItem === item.id ? (
                    <div
                      className={`custom-menu-item ${
                        currentSelect1 === item.id ? 'custom-menu-item-selected' : ''
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSelected1(item.id);
                      }}
                    >
                      <Input
                        onClick={(e) => e.stopPropagation()}
                        className="custom-menu-item-input"
                        defaultValue={item.catName}
                        onChange={(e) => {
                          setFirstChangeValue(e.target.value);
                        }}
                      />
                      &nbsp;
                      <img
                        src={checkSvg}
                        width="30"
                        alt="确定"
                        onClick={(e) => {
                          e.stopPropagation();
                          const _customMenu = clone(customMenuRef.current);
                          _customMenu.forEach((i) => {
                            if (i.id === item.id) {
                              i.catName = firstChangeValue;
                            }
                          });
                          setCustomMenu(_customMenu);
                          setCurrentEditItem(null);
                          customMenuRef.current = _customMenu;
                        }}
                      />
                      &nbsp;
                      <img
                        src={closeSvg}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentEditItem(null);
                        }}
                        width="30"
                        alt="删除"
                      />
                    </div>
                  ) : (
                    <div
                      className={`custom-menu-item ${
                        currentSelect1 === item.id ? 'custom-menu-item-selected' : ''
                      }`}
                      onClick={() => handleSelected1(item.id)}
                    >
                      <span className="item-text ellipsis">{item.catName}</span>
                      {/* 内置大类不可操作 */}
                      {item.fixedMenuFlag === '0' ? (
                        <span className="operate-icon">
                          &nbsp;
                          <Icon
                            title="编辑"
                            onClick={(e) => {
                              e.stopPropagation();
                              setFirstChangeValue(item.catName);
                              handleItemEdit(item.id);
                            }}
                            className="edit-icon"
                            type="form"
                          />
                          &nbsp;
                          <Icon
                            title="删除"
                            className="delete-icon"
                            type="delete"
                            onClick={(e) => {
                              e.stopPropagation();
                              const _customMenu = clone(customMenuRef.current);
                              const arr = _customMenu.filter((i) => i.id !== item.id);
                              setCustomMenu(arr);
                              customMenuRef.current = arr;
                              if (item.id === currentSelect1) {
                                setCurrentMenuSecond([]);
                                setCurrentMenuThird([]);
                                setTreeVisible(false);
                              }
                            }}
                          />
                          &nbsp;
                          <Icon
                            className="edit-icon"
                            type="up-square"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (index > 0) {
                                const _customMenu = clone(customMenuRef.current);
                                // eslint-disable-next-line prefer-destructuring
                                _customMenu[index - 1] = _customMenu.splice(
                                  index,
                                  1,
                                  _customMenu[index - 1],
                                )[0];
                                setCustomMenu(_customMenu);
                                customMenuRef.current = _customMenu;
                              }
                            }}
                          />
                          &nbsp;
                          <Icon
                            className="edit-icon"
                            type="down-square"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (index < customMenu.length - 1) {
                                const _customMenu = clone(customMenuRef.current);
                                // eslint-disable-next-line prefer-destructuring
                                _customMenu[index] = _customMenu.splice(
                                  index + 1,
                                  1,
                                  _customMenu[index],
                                )[0];
                                setCustomMenu(_customMenu);
                              }
                            }}
                          />
                        </span>
                      ) : null}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
        {/* 二级菜单区域 */}
        <div className="custom-menu custom-menu-second">
          <div className="custom-menu-title">
            <span>
              <Icon type="appstore" />
              &nbsp;二级菜单
            </span>
            <span className="right-icon">
              <Icon type="plus-square" onClick={handleAddSecond} />
            </span>
          </div>
          <div
            className="custom-menu-content"
            ref={(ref) => {
              secondContentRef.current = ref;
            }}
          >
            {secondAddList.map((item) => (
              <div className="custom-menu-item-add" key={item.id}>
                <Input
                  className="custom-menu-item-input"
                  onChange={(e) => handleSecondOnchange(item.id, e.target.value)}
                />
                &nbsp;
                <img
                  src={checkSvg}
                  width="30"
                  alt="确定"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSecondConfirm(item.id);
                  }}
                />
                &nbsp;
                <img
                  src={closeSvg}
                  width="30"
                  alt="删除"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSecondDelete(item.id);
                  }}
                />
              </div>
            ))}
            {currentMenuSecond &&
              currentMenuSecond.map((item, index) => (
                <div key={item.id}>
                  {currentEditItem2 === item.id ? (
                    <div
                      className={`custom-menu-item ${
                        currentSelect2 === item.id ? 'custom-menu-item-selected' : ''
                      }`}
                      onClick={() => handleSelected2(item.id)}
                    >
                      <Input
                        className="custom-menu-item-input"
                        defaultValue={item.catName}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          setSecondChangeValue(e.target.value);
                        }}
                      />
                      &nbsp;
                      <img
                        src={checkSvg}
                        width="30"
                        alt="确定"
                        onClick={(e) => {
                          e.stopPropagation();
                          const list = clone(currentMenuSecond);
                          list.forEach((i) => {
                            if (i.id === item.id) {
                              i.catName = secondChangeValue;
                            }
                          });
                          setCurrentMenuSecond(list);
                          const _customMenu = clone(customMenuRef.current);
                          _customMenu.forEach((i) => {
                            if (i.id === currentSelect1) {
                              i.children &&
                                i.children.forEach((i2) => {
                                  if (i2.id === item.id) {
                                    i2.catName = secondChangeValue;
                                  }
                                });
                            }
                          });
                          setCustomMenu(_customMenu);
                          setCurrentEditItem2(null);
                          customMenuRef.current = _customMenu;
                        }}
                      />
                      &nbsp;
                      <img
                        src={closeSvg}
                        onClick={() => {
                          setCurrentEditItem2(null);
                        }}
                        width="30"
                        alt="删除"
                      />
                    </div>
                  ) : (
                    <div
                      className={`custom-menu-item ${
                        currentSelect2 === item.id ? 'custom-menu-item-selected' : ''
                      }`}
                      onClick={() => handleSelected2(item.id)}
                    >
                      <span className="item-text ellipsis">{item.catName}</span>
                      {item.fixedMenuFlag === '0' ? (
                        <span className="operate-icon">
                          &nbsp;
                          <Icon
                            title="编辑"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSecondChangeValue(item.catName);
                              handleItemEdit2(item.id);
                            }}
                            className="edit-icon"
                            type="form"
                          />
                          &nbsp;
                          <Icon
                            title="删除"
                            className="delete-icon"
                            type="delete"
                            onClick={(e) => {
                              e.stopPropagation();
                              const arr = currentMenuSecond.filter((i) => i.id !== item.id);
                              setCurrentMenuSecond(arr);
                              const _customMenu = clone(customMenuRef.current);
                              _customMenu.forEach((item1) => {
                                if (item1.id === currentSelect1) {
                                  if (item1.children) {
                                    item1.children = item1.children.filter((i) => i.id !== item.id);
                                  }
                                }
                              });
                              setCustomMenu(_customMenu);
                              customMenuRef.current = _customMenu;
                              if (item.id === currentSelect2) {
                                setCurrentMenuThird([]);
                                setTreeVisible(false);
                              }
                            }}
                          />
                          &nbsp;
                          <Icon
                            className="edit-icon"
                            type="up-square"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (index > 0) {
                                const list = clone(currentMenuSecond);
                                // eslint-disable-next-line prefer-destructuring
                                list[index - 1] = list.splice(index, 1, list[index - 1])[0];
                                setCurrentMenuSecond(list);

                                const _customMenu = clone(customMenuRef.current);
                                _customMenu.forEach((i) => {
                                  if (i.id === currentSelect1) {
                                    if (i.children) {
                                      // eslint-disable-next-line prefer-destructuring
                                      i.children[index - 1] = i.children.splice(
                                        index,
                                        1,
                                        i.children[index - 1],
                                      )[0];
                                    }
                                  }
                                });
                                setCustomMenu(_customMenu);
                                customMenuRef.current = _customMenu;
                              }
                            }}
                          />
                          &nbsp;
                          <Icon
                            className="edit-icon"
                            type="down-square"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (index < currentMenuSecond.length - 1) {
                                const list = clone(currentMenuSecond);
                                // eslint-disable-next-line prefer-destructuring
                                list[index] = list.splice(index + 1, 1, list[index])[0];
                                setCurrentMenuSecond(list);

                                const _customMenu = clone(customMenuRef.current);
                                _customMenu.forEach((i) => {
                                  if (i.id === currentSelect1) {
                                    if (i.children) {
                                      // eslint-disable-next-line prefer-destructuring
                                      i.children[index] = i.children.splice(
                                        index + 1,
                                        1,
                                        i.children[index],
                                      )[0];
                                    }
                                  }
                                });
                                setCustomMenu(_customMenu);
                                customMenuRef.current = _customMenu;
                              }
                            }}
                          />
                        </span>
                      ) : null}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
        {/* 三级菜单区域 */}
        <div className="custom-menu custom-menu-third">
          <div className="custom-menu-title">
            <span>
              <Icon type="appstore" />
              &nbsp;三级菜单
              <span style={{ color: '#FF474A' }}>(勾选右侧菜单添加)</span>
            </span>
          </div>
          <div className="custom-menu-content">
            {currentMenuThird &&
              currentMenuThird.map((item, index) => (
                <div key={item.catCode}>
                  <div className="custom-menu-item">
                    <span className="item-text ellipsis">{item.catName}</span>
                    {currentThirdFixed === '0' ? (
                      <span className="operate-icon">
                        &nbsp;
                        <Icon
                          className="delete-icon"
                          type="delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            const menuThirdRef = customMenuRef.current
                              .find((i) => i.id === currentSelect1)
                              .children.find((i) => i.id === currentSelect2Ref.current).children;
                            // 此处没有id，用catCode
                            const arr = menuThirdRef.filter((i) => i.catCode !== item.catCode);
                            // 定位区域
                            setCurrentMenuThird(arr);
                            const _customMenu = clone(customMenuRef.current);
                            _customMenu.forEach((item1) => {
                              if (item1.id === currentSelect1) {
                                if (item1.children) {
                                  item1.children.forEach((item2) => {
                                    if (item2.id === currentSelect2Ref.current) {
                                      if (item2.children) {
                                        item2.children = item2.children.filter(
                                          // 此处没有id，用catCode
                                          (i) => i.catCode !== item.catCode,
                                        );
                                      }
                                    }
                                  });
                                }
                              }
                            });
                            setCustomMenu(_customMenu);
                            // 同步取消勾选
                            const list = checkedKeys.filter((i) => i !== item.catCode);
                            setCheckedKeys(list);
                            customMenuRef.current = _customMenu;
                          }}
                        />
                        &nbsp;
                        <Icon
                          className="edit-icon"
                          type="up-square"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (index > 0) {
                              const list = clone(currentMenuThird);
                              // eslint-disable-next-line prefer-destructuring
                              list[index - 1] = list.splice(index, 1, list[index - 1])[0];
                              setCurrentMenuThird(list);
                              // 同步Tree顺序
                              const tree = clone(checkedKeys);
                              // eslint-disable-next-line prefer-destructuring
                              tree[index - 1] = tree.splice(index, 1, tree[index - 1])[0];
                              setCheckedKeys(tree);
                              const _customMenu = clone(customMenuRef.current);
                              _customMenu.forEach((i) => {
                                if (i.id === currentSelect1) {
                                  if (i.children) {
                                    i.children.forEach((i) => {
                                      if (i.id === currentSelect2) {
                                        // eslint-disable-next-line prefer-destructuring
                                        i.children[index - 1] = i.children.splice(
                                          index,
                                          1,
                                          i.children[index - 1],
                                        )[0];
                                      }
                                    });
                                  }
                                }
                              });
                              setCustomMenu(_customMenu);
                              customMenuRef.current = _customMenu;
                            }
                          }}
                        />
                        &nbsp;
                        <Icon
                          className="edit-icon"
                          type="down-square"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (index < currentMenuThird.length - 1) {
                              const list = clone(currentMenuThird);
                              // eslint-disable-next-line prefer-destructuring
                              list[index] = list.splice(index + 1, 1, list[index])[0];
                              setCurrentMenuThird(list);
                              // 同步Tree顺序
                              const tree = clone(checkedKeys);
                              // eslint-disable-next-line prefer-destructuring
                              tree[index] = tree.splice(index + 1, 1, tree[index])[0];
                              setCheckedKeys(tree);
                              const _customMenu = clone(customMenuRef.current);
                              _customMenu.forEach((i) => {
                                if (i.id === currentSelect1) {
                                  if (i.children) {
                                    i.children.forEach((i) => {
                                      if (i.id === currentSelect2) {
                                        // eslint-disable-next-line prefer-destructuring
                                        i.children[index] = i.children.splice(
                                          index + 1,
                                          1,
                                          i.children[index],
                                        )[0];
                                      }
                                    });
                                  }
                                }
                              });
                              setCustomMenu(_customMenu);
                              customMenuRef.current = _customMenu;
                            }
                          }}
                        />
                      </span>
                    ) : null}
                  </div>
                </div>
              ))}
          </div>
        </div>
        {/* 全部菜单区域 */}
        <div className="custom-menu custom-menu-all">
          <div className="custom-menu-title">
            <span>
              <Icon type="appstore" />
              &nbsp;全部菜单
            </span>
          </div>
          <div className="custom-menu-content">
            {treeVisible ? (
              <Tree
                checkable
                selectable={false}
                onExpand={onExpand}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                onCheck={onCheck}
                checkedKeys={checkedKeys}
              >
                {renderTreeNodes(allMenus)}
              </Tree>
            ) : null}
          </div>
        </div>
      </Modal>
      <div className="category-menu disable-copy">
        <Icon type={!!loading['fetchMenu'] ? 'loading' : 'unordered-list'} />
        {showCustomMenu ? '我的商品 ' : '全部商品 '}
        {customOpeartionVisible ? (
          <Switch
            checked={showCustomMenu}
            checkedChildren="开启自定义"
            unCheckedChildren="关闭自定义"
            onChange={(val) => {
              const loginName = localStorage.getItem('loginName');
              localStorage.setItem(`${loginName}-custom-menu`, val);
              setShowCustomMenu(val);
            }}
          />
        ) : null}
        <div
          className="category-menu-list-wrapper"
          ref={(ref) => {
            mainRef.current = ref;
          }}
          style={!!visible ? { display: 'block' } : {}}
        >
          <div key={`${hoverFix}`} className="category-menu-wrapper">
            <div className={`category-menu-main ${carouselReact}`}>
              {!!loading['fetchMenu'] ? (
                <Spin delay={300} size="large" tip="菜单加载中..." />
              ) : showCustomMenu ? (
                memorizedCustomMenu
              ) : (
                memorizedMainMenu
              )}
              {customOpeartionVisible && showCustomMenu ? (
                <Button
                  type="primary"
                  style={{
                    margin: '10px 40px',
                  }}
                  onClick={() => {
                    setModalVisible(true);
                    // mainRef.current.classList.add('hidden');
                  }}
                >
                  编辑自定义菜单
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CatMenu;
